var map = {
	"./evoting-no-weight.json": 579,
	"./evoting.json": 580
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 578;



//////////////////
// WEBPACK FOOTER
// ./client/components/schemas ^\.\/.*\.json$
// module id = 578
// module chunks = 0